module.exports = __webpack_public_path__ + "static/Service-staup-author1-c60f2e64cbccc8e2600a5e8ee8f96dd5.png";